module.exports = __webpack_public_path__ + "img/reg-success.e78aa461.png";